import type {ValidationResult} from './types';

export const validResult = (): ValidationResult => ({
  valid: 'valid',
  errors: [],
});
